import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ec1ad0c8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "blueNlSub col-12 mb-4"
};
const _hoisted_2 = { class: "col-12 py-3 pr-3 bg-white border rounded form-group" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon-mail-und-newsletter float-right" }, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_switch_toggle = _resolveComponent("switch-toggle");
    return (_ctx.showNewsletterRegistration)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_switch_toggle, {
                    id: "newsletter_toggle",
                    name: "newsletter_toggle",
                    title: "",
                    modelValue: _ctx.shouldRegisterNewsletter,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.shouldRegisterNewsletter) = $event)),
                    style: { "width": "auto", "display": "inline-block" }
                }, {
                    default: _withCtx(() => [
                        _createTextVNode(" Ich möchte mich für den Newsletter anmelden. "),
                        _hoisted_3
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ])
        ]))
        : _createCommentVNode("", true);
}
